import { useState } from 'react'

export function useNavigation() {
  const [route, setRoute] = useState("dashboard")
  const [history, setHistory] = useState(["dashboard"])

  const go = (r) => {
    if (r !== route) {
      setRoute(r)
      setHistory((h) => [...h, r])
    }
    window.scrollTo(0, 0)
  }

  const goBack = () => {
    if (history.length > 1) {
      const newHistory = history.slice(0, -1)
      setHistory(newHistory)
      setRoute(newHistory[newHistory.length - 1])
      window.scrollTo(0, 0)
    }
  }

  return {
    route,
    setRoute,
    history,
    setHistory,
    go,
    goBack,
  }
}
